// import 'bootstrap';
import { renderBarChart, renderLineChart } from "./charts";
import SiteApiResponse from "./site_api_response";
import "./index.scss";
import pending from "./pending.hbs";
import success from "./success.hbs";
import err from "./error.hbs";
import notFound from "./not_found.hbs";

function renderPending() {
  document.body.innerHTML = pending();
}

function renderSuccess(apiResponse) {
  document.body.classList.remove("pending");
  document.body.innerHTML = success({ data: apiResponse });
  document.title = `${apiResponse.name} - Uptime`;

  renderBarChart("uptime-day-graph", apiResponse.uptimeByDaySeries);
  renderBarChart("uptime-month-graph", apiResponse.uptimeByMonthSeries);
  renderLineChart(
    "response-day-graph",
    apiResponse.responseByDaySeries,
    "MMM D"
  );
  renderLineChart(
    "response-hour-graph",
    apiResponse.responseByHourSeries,
    "LT"
  );
}

function renderError() {
  document.body.innerHTML = err();
}

function renderNotFound() {
  document.body.innerHTML = notFound();
}

function loadData(siteId) {
  const xhr = new XMLHttpRequest();
  renderPending();
  xhr.open("GET", `https://app.hbuptime.com/site/${siteId}.json`);
  xhr.addEventListener("load", () => {
    if (xhr.status === 200) {
      renderSuccess(new SiteApiResponse(xhr.responseText));
    } else if (xhr.status === 404) {
      renderNotFound();
    } else {
      renderError();
    }
  });

  xhr.send(null);
}

const siteId = window.location.hostname.split(".")[0];

if (
  siteId.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)
) {
  loadData(siteId);
} else {
  renderNotFound();
}



// WEBPACK FOOTER //
// ./src/index.js